<template>
  <div id="main-box" class="page-content">
    <div class="home-box">
      <!--<div class="swiper-container home-hint">
        <div class="swiper-wrapper">
          <div class="swiper-slide notice-row" v-for="item in notice" v-text="item"></div>
        </div>
      </div>-->

      <div class="nav-box">
        <ul class="nav-main" v-for="(item,index) in navlist" v-on:click="OpenPage(item.url)">
          <li class="nav-main-icon"><i class="fa" :class="item.icon"></i></li>
          <li class="nav-main-right">
            <p v-text="item.name"></p>
            <p v-text="item.count"></p>
          </li>
        </ul>
      </div>
    </div>

    <div class="chart-box" style="margin-top: 20px;">
      <div class="chart-consume" id="ConsumeChart"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>


  </div>
</template>

<script>
var self,ConsumeChart;
import axios from 'axios'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'HomePage',
  components: {
    'K-Loading': Loading,
    'K-Toast': Toast,
  },
  data () {
    return {
      name:"黑领科技",
      loading: false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      isLogin:true,
      money:0,
      navlist:[{
        id:1,
        count:0,
        icon:"fa-star",
        name:"已授权店铺",
        url:"Shops"
      },{
        id:2,
        count:0,
        icon:"fa-shield",
        name:"可使用店铺",
        url:"Shops"
      },{
        id:3,
        count:0,
        icon:"fa-quote-right",
        name:"图片翻译次数",
        url:"Purchased"
      },{
        id:4,
        count:0,
        icon:"fa-hashtag",
        name:"图片剩余次数",
        url:"Purchased"
      },{
        id:5,
        count:0,
        icon:"fa-cloud-download",
        name:"采集商品数",
        url:"Col"
      }],
      orders:[],
      notice:[
        "邀请好友注册exshopee并绑定店铺成功后，可获返10积分！",
        "ExShopee上架功能开启，点击上方导航 “上架” 按钮，免费使用吧！",
        "新用户注册可免费获赠5积分！",
        "Exshopee货代已开通上海仓，如果需要使用上海仓可在店铺列表切换！",
      ]
    }
  },
  mounted () {
    self = this;
    self.SetNavActive("上架",self.$route.name);
    self.GetUserPackage();
    self.GetHomePageInfo();

    if(localStorage.getItem("ExShopee_id")){
      self.name = self.name + localStorage.getItem("ExShopee_id")
    }

    //屏幕宽度改变图表自动适应
    window.addEventListener('resize',function(){
    	self.ChangeChartWidth();
    })

    //滚动公告
    var mySwiper = new Swiper('.swiper-container', {
    	autoplay: {
        delay: 3000,
      },
    	loop: true,
      direction: 'vertical',
    })
  },
  methods:{
    drawLine(datas){
        // 基于准备好的dom，初始化echarts实例
        ConsumeChart = self.$echarts.init(document.getElementById('ConsumeChart'))
        var numlist = [],datelist = [];
        numlist = datas.count;
        datelist = datas.date;

        let option = {
						title: {
							top: 20,
							left:20,
							text: '采集商品数',
							subtext: 'Number of products collected'
						},
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
						grid: {
							top: 90,
              left: 55,
							bottom: 30,
							right: 40,
              borderColor:"#F00"
						},
            xAxis: {
                type: 'category',
                data: datelist,
                axisLine: {
                    show:false,
                    lineStyle: {
                        color: ['rgba(128, 128, 128,0.8)'],
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: ['rgba(128, 128, 128,0.6)'],
                    }
                }
            },
            series: [{
                data: numlist,
                type: 'line',
                symbolSize:10,
                itemStyle: {
                	color: "#65bdf8",
                  borderWidth:3
                }
            }]
        };

        // 绘制图表
        ConsumeChart.setOption(option);
    },
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    GetUserPackage() {
      let param = new URLSearchParams()
      axios({
        method: 'post',
        url: self.GetServerUrl() + "/user_package/",
        data: param,
        headers: {
          'token': localStorage.getItem("ExShopee_token")
        }
      }).then(function(response) {

        //返回数据处理
        self.ReturnFuntion(self, response, function(datas) {
          self.navlist[0].count = datas.shop_count;
          self.navlist[1].count = datas.shop_limit;
          self.navlist[2].count = datas.package_img.ali_image_transl_count;
          self.navlist[3].count = datas.package_img.ali_image_transl_limit - datas.package_img.ali_image_transl_count;
          self.navlist[4].count = datas.collection_count;
        }, false, true);

      }).catch(function(error) {
        console.log(error);
      })
    },
    GetHomePageInfo() {
      let param = new URLSearchParams()
      axios({
        method: 'post',
        url: self.GetServerUrl() + "/get_collection_count/",
        data: param,
        headers: {
          'token': localStorage.getItem("ExShopee_token")
        }
      }).then(function(response) {

        //返回数据处理
        self.ReturnFuntion(self, response, function(datas) {
          self.drawLine(datas);
        }, false, true);

      }).catch(function(error) {
        console.log(error);
      })
    },
    OpenPage (url) {
      localStorage.setItem("ExShopee_HistoryURL",url);
      self.GoToPage('/'+url); // 路由跳转
    },
    ChangeChartWidth(){
      ConsumeChart.resize();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-box{
  padding:20px 20px 0 20px;
}
.nav-box{
  overflow: hidden;
}
.nav-main{
  float: left;
  width: calc(18.39% - 40px);
  background-color: #33cabb;
  margin-right: 2%;
  padding:30px 20px;;
  cursor: pointer;
  border-radius: 5px;
}
.nav-main:hover{
  opacity: 0.9;
}
.nav-main:last-child{
  margin-right: 0%;
}
.nav-main-icon{
  display: inline-block;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  color: #FFF;
  float: left;
  text-align: center;
  font-size: 1.5em;
  line-height: 48px;
  background-color: rgba(255, 255, 255, 0.175);
}
.nav-main-icon img{
  display: table;
  width: 100%;
}
.nav-main-left{
  float: left;
}
.nav-main-right{
  float: right;
  color: #FFF;
}
.nav-main-right p:first-child{
  font-size: 14px;
}
.nav-main-right p:last-child{
  font-size: 2em;
  margin-top: 10px;
  text-align: center;
}
.nav-main:nth-child(1){
  background-color: #33cabb;
}
.nav-main:nth-child(2){
  background-color: #65bdf8;
}
.nav-main:nth-child(3){
  background-color: #15c377;
}
.nav-main:nth-child(4){
  background-color: #f96868;
}
.nav-main:nth-child(5){
  background-color: #926dde;
}

.chart-box{
  position: relative;
  padding:0 20px 20px 20px;
}
.chart-consume{
  width: 100%;
  height: 450px;
  border-radius: 5px;
  background-color: #FFF;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/product/HomePage.vue